import { sameNodePosition, } from "../../components/markdown/utils";
import React, { memo } from "react";
export const HrBlock = memo((_props) => (React.createElement("div", { className: "my-4 border-b border-primary-150" })), (prev, next) => sameNodePosition(prev.node, next.node));
HrBlock.displayName = "HrBlock";
//# sourceMappingURL=HrBlock.js.map